import OtherLayout from "../web-sh/src/layouts/other";

export default OtherLayout;